import {api} from "@/shared/api";
import {Integrations} from "../integrations";
import {PanelBase} from "./panelBase";
import * as BootstrapModal from "@/shared/ui/bootstrapModal";
import * as Button from "@/shared/utils/button";
import {IntegrationType} from "@/shared/timrTypes";

export class Jira extends PanelBase {

	private static CONNECT_JIRA_URL: string;

	public static setConnectJiraUrl(url: string) {
		Jira.CONNECT_JIRA_URL = url;
	}

	public static getConnectJiraUrl(): string {
		return Jira.CONNECT_JIRA_URL;
	}

	// Called when the element is inserted in the DOM
	// DEVNOTE: No shadow DOM here, so we can use external css
	private connectedCallback() {
		this.innerHTML = this.renderPanel({
			logoHtml: `<img src="/timr/images/integrations/jira.svg" alt="Jira" height="36px">`,
			footerHtml: `
				<button type="button" data-manual-sync class="btn btn-primary mt-10 mb-0 mr-10">
					<i class="far fa-sync-alt position-left" aria-hidden="true"></i>${messages["integrations.jira.manualSync"]}
				</button>
			`
		});
		this.initListeners();
	}

	private initListeners() {
		this.querySelector("[data-delete-integration]").addEventListener("click", () => {
			BootstrapModal.confirm({
				title: messages["dialog.delete.confirm"],
				message: messages["integrations.jira.delete.message"],
				yesAction: (confirmModal) => {
					confirmModal.close();
					Integrations.triggerDeletedIntegrationEvent(IntegrationType.JIRA, this.integration.id);
				}
			});
		});
		this.querySelector("[data-manual-sync]").addEventListener("click", (e) => {
			const button = e.target as HTMLElement;
			Button.setLoading(button);
			void api("integrations/jira/triggerSync.json")
				.post({id: this.integration.id})
				.always(() => Button.resetLoading(button));
		});
	}

	protected updateBanner(): void {
		// Nothing to do here
	}

	public onIntegrationAdded() {
		// open jira connect url in a new tab
		window.open(Jira.getConnectJiraUrl(), "_blank", "noreferrer");
	}
}
